module.exports = __webpack_public_path__ + "img/living_4.7fdb4a89.jpg";